"use client";

import { Product } from '@/types';
import { Card, CardBody } from '@nextui-org/react';
import Image from 'next/image';
import React from 'react'
import { MdFullscreen } from 'react-icons/md';

const ImagesNInfo = ({
    images,
    product,
}: {
    images: string[];
    product: Product;
}) => {
    const [selectedImage, setSelectedImage] = React.useState(images[0]);
    const [showFullScreen, setShowFullScreen] = React.useState(false);

    return (
        <div className="w-full h-fit items-start grid grid-cols-12 gap-4 lg:max-w-none max-w-[720px] max-h-fit">
            <div
                className='rounded-lg w-full h-full object-cover sm:col-span-8 col-span-12 object-center lg:max-w-[512px] max-w-[720px] relative block max-h-fit'
            >
                <Image
                    src={selectedImage}
                    width={512}
                    height={512}
                    alt={product.name}
                    onDoubleClick={() => setShowFullScreen(true)}
                    className="rounded-lg w-full h-auto object-cover object-center"
                />
                <button
                    className="absolute top-4 right-4 p-2 bg-white rounded-full shadow-md"
                    onClick={() => setShowFullScreen(true)}
                >
                    <MdFullscreen />
                </button>
            </div>
            <div className="sm:col-span-4 col-span-12 gap-4 justify-self-center flex-wrap flex sm:flex-col">
                <Card className="rounded-md shadow-sm sm:w-full w-[calc(50%-0.5rem)]">
                    <CardBody className="text-sm text-center items-center gap-2 p-3">
                        <Image
                            src="/icons/authenticity.png"
                            width={36}
                            height={36}
                            alt="Authentic"
                        />
                        100%  Natural Ingredients
                    </CardBody>
                </Card>
                <Card className="rounded-md shadow-sm sm:w-full w-[calc(50%-0.5rem)]">
                    <CardBody className="text-sm text-center items-center gap-2 p-3">
                        <Image
                            src="/icons/sourced.png"
                            width={36}
                            height={36}
                            alt="Sourced"
                        />
                        {
                            product.category === "Snacks" ? "Made with affection in the heartland of India" : "Picked from various private sources across India"
                        }
                    </CardBody>
                </Card>
                <Card className="rounded-md shadow-sm sm:w-full w-[calc(50%-0.5rem)]">
                    <CardBody className="text-sm text-center items-center gap-2 p-3">
                        <Image
                            src="/icons/fresh.png"
                            width={36}
                            height={36}
                            alt="fresh"
                        />
                        Endeavor towards innovation, quality & consistency.
                    </CardBody>
                </Card>
                <Card className="rounded-md shadow-sm sm:w-full w-[calc(50%-0.5rem)]">
                    <CardBody className="text-sm text-center items-center gap-2 p-3">
                        <Image
                            src="/icons/india-gate.png"
                            width={36}
                            height={36}
                            alt="India"
                        />
                        {
                            product.category === "Snacks" ? "Experience the Authentic taste of Homemade snacks" : "Experience the vibrant flavors of Authentic Homemade Chai."
                        }
                    </CardBody>
                </Card>
            </div>
            <br className='col-span-12' />
            <br className='col-span-12' />
            <div className="grid col-span-12 grid-cols-3 gap-4 w-full lg:max-w-none max-w-[720px] mx-auto">
                {
                    images.length > 1 && images.map((image: string, index: number) => {
                        return (
                            <Image
                                key={index}
                                src={image}
                                width={400}
                                height={400}
                                alt={product.name}
                                onClick={() => setSelectedImage(image)}
                                className={`w-full object-cover max-h-[200px] object-top h-full rounded-lg cursor-pointer ${selectedImage === image ? "border-2 border-green-500" : "opacity-50"}`}
                            />
                        );
                    })}
            </div>
            {
                showFullScreen && (
                    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center">
                        <div className="w-full h-full items-center flex justify-center cursor-pointer p-4"
                            onClick={() => setShowFullScreen(false)}
                        >

                        </div>
                        <Image
                            src={selectedImage}
                            width={1080}
                            height={1080}
                            alt={product.name}
                            draggable={false}
                            onClick={() => setShowFullScreen(false)}
                            className="absolute rounded-lg h-auto object-center max-w-[720px] object-contain top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[94%] max-h-[90vh] overflow-y-scroll cursor-pointer"
                        />
                    </div>
                )
            }
        </div>
    )
}

export default ImagesNInfo